import React, { useEffect, useState } from "react";

const CHANNEL_ID = process.env.REACT_APP_YOUTUBE_CHANNEL_ID; // Use environment variables for security
const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
const MAX_RESULTS = 8; // Fetch last 8 videos (you can adjust)

const Music = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchVideos = async () => {
      try {
        const res = await fetch(
          `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${CHANNEL_ID}&maxResults=${MAX_RESULTS}&order=date&type=video&key=${API_KEY}`,
          { signal }
        );
        const data = await res.json();

        if (data.items) {
          setVideos(data.items);
        } else {
          console.error("No videos found.");
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error fetching YouTube videos:", err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
    return () => controller.abort(); // Cleanup function to prevent memory leaks
  }, []);

  return (
    <section className="page-section">
      <h1>Music</h1>
      {loading ? (
        <h2>Loading videos...</h2>
      ) : (
        <div className="videos-grid">
          {videos.map((video) => (
            <div key={video.id.videoId} className="video-card">
              <h3>{video.snippet.title}</h3>
              <iframe
                width="100%"
                height="250"
                src={`https://www.youtube.com/embed/${video.id.videoId}`}
                frameBorder="0"
                allowFullScreen
                title={video.snippet.title}
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default Music;
